// AAL approval rules.
// 0 = no approval required
// 1 = editor is the approver, commit straight away
// 2 = needs second approval, show popup + save to pending tables

// Must match AalWorkflowable::APPROVAL_RULE_FIELDS in the API.
// Approvers and Authorised Access List contacts may view, edit and approve an AAL (requests stay Approver-only)
export const canManageAal = (attrs) => !!(attrs?.approver || attrs?.authorised_access_list);

export const AAL_APPROVAL_RULES = {
  fields: {
    access_request: 0,
    service_request: 0,
    change_request: 0,

    approver: 2,
    authorised_access_list: 2,
    site_access: 1,
    is_primary: 1,
    reporting: 2,
    maintenance: 1,
    tape_management: 1,
    billing: 1,
    invoicing_contact: 1,
    escalation: 1,
    rack_status: 1,
  },
  operations: {
    create: 2,
    delete: 2,
  },
};

function getRowKey(row) {
  return row._tempKey ? row._tempKey : `id-${row.id}`;
}

// Blank, false and "None" all mean "not set"
const unsetToNull = (v) =>
  v === '' || v === null || v === undefined || v === false || v === 'None' ? null : v;

export function computeApprovalsNeeded({
  editedContacts,
  dirtyKeys,
  deletedKeys,
  originalContacts,
  exemptApprover = false,
}) {
  let max = 0;

  const hasCreate = editedContacts.some((r) => r._isNew && dirtyKeys.has(getRowKey(r)));
  const hasDelete = deletedKeys.size > 0;

  if (hasCreate) max = Math.max(max, AAL_APPROVAL_RULES.operations.create || 0);
  if (hasDelete) max = Math.max(max, AAL_APPROVAL_RULES.operations.delete || 0);

  editedContacts.forEach((row) => {
    const key = getRowKey(row);
    if (!dirtyKeys.has(key)) return;

    // For rows created in this session, compare against sensible defaults
    if (row._isNew) {
      Object.keys(AAL_APPROVAL_RULES.fields).forEach((field) => {
        const v = row[field];
        if (v !== undefined && v !== null && v !== false && v !== 'None') {
          max = Math.max(max, AAL_APPROVAL_RULES.fields[field] || 0);
        }
      });
      return;
    }

    const original = originalContacts.find((c) => String(c.id) === String(row.id));
    if (!original) return;

    Object.keys(AAL_APPROVAL_RULES.fields).forEach((field) => {
      if (unsetToNull(row[field]) !== unsetToNull(original[field])) {
        max = Math.max(max, AAL_APPROVAL_RULES.fields[field] || 0);
      }
    });
  });

  // Customer-level exemption caps 2 approvals down to 1
  if (exemptApprover) max = Math.min(max, 1);

  return max;
}
